import { Box, Chip, CircularProgress, Fade, Typography } from "@mui/material";
import React from "react";
import { styles } from "../../../assets/MUIStyles/agentStyle";
import { converTime } from "../CommonComponents/Common";
import BaseButton from "../Common/Buttons/BaseButton";

const getStatusConfig = (status: string) => {
  const configs = {
    success: {
      color: "#2E7D32",
      bgColor: "#E8F5E9",
      borderColor: "#4CAF50",
      icon: "✓",
      label: "Completed",
    },
    failed: {
      color: "#C62828",
      bgColor: "#FFEBEE",
      borderColor: "#F44336",
      icon: "✕",
      label: "Failed",
    },
    in_progress: {
      color: "#1565C0",
      bgColor: "#E3F2FD",
      borderColor: "#2196F3",
      icon: "⟳",
      label: "In Progress",
    },
    pending: {
      color: "#E65100",
      bgColor: "#FFF3E0",
      borderColor: "#FF9800",
      icon: "⋯",
      label: "Pending",
    },
  };
  return configs[status] || configs.pending;
};

const TestCard = ({
  objection,
  isOngoing = false,
  state,
  setState,
  handleLatestStatus,
}) => {
  const { loadingButtons } = state;

  const statusConfig = getStatusConfig(objection.status);

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          ...styles.testStatusCard,
          p: 2.5,
          borderRadius: 2.5,
          border: "1px solid #E0E0E0",
          bgcolor: "white",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
          transition: "all 0.3s ease",
          position: "relative",
          overflow: "hidden",
          "&:hover": {
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
            transform: "translateY(-2px)",
          },
        }}
      >
        <Box className=" w-full flex-between gap-2">
          <Box>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontWeight: 500,
                display: "block",
                mb: 0.5,
              }}
            >
              {converTime(objection?.created_date)}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.7rem",
                color: "text.disabled",
                fontFamily: "monospace",
                wordBreak: "break-all",
              }}
            >
              {objection.object_id}
            </Typography>
          </Box>

          <Box className="flex-column gap-2">
            {!isOngoing && objection.status && (
              <Chip
                icon={
                  <span style={{ fontSize: "0.9rem" }}>
                    {statusConfig.icon}
                  </span>
                }
                label={statusConfig.label}
                size="small"
                sx={{
                  bgcolor: statusConfig.bgColor,
                  color: statusConfig.color,
                  border: `1.5px solid ${statusConfig.borderColor}`,
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  height: 26,
                  "& .MuiChip-icon": {
                    color: statusConfig.color,
                    marginLeft: "8px",
                  },
                }}
              />
            )}
            {isOngoing ? (
              <BaseButton
                variant="contained"
                title={
                  loadingButtons[objection.object_id] ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={16} color="inherit" />
                      <span>Checking...</span>
                    </Box>
                  ) : (
                    "Check Status"
                  )
                }
                handleClick={(event) =>
                  handleLatestStatus(objection.object_id, event)
                }
                loading={!!loadingButtons[objection.object_id]}
                styles={{
                  textTransform: "none",
                  fontWeight: 600,
                  px: 2.5,
                }}
              />
            ) : objection.status === "success" ? (
              <BaseButton
                variant="outlined"
                title="View Chat"
                handleClick={() =>
                  setState((prev) => ({
                    ...prev,
                    chatData: objection?.data,
                  }))
                }
                styles={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                  px: 2.5,
                  py: 0.25,
                  "&:hover": {
                    borderColor: "#388E3C",
                    bgcolor: "#E8F5E9",
                  },
                }}
              />
            ) : null}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default TestCard;
